import { requestApi } from "./axiosHelper"

const rootUrl = process.env.REACT_APP_API_ROOT_URL
const ambsdrURL = rootUrl + "/ambassador/user"

export const fetchAllAmbassadors = async (_id) => {
  try {
    const axiosData = {
      url: _id ? `${ambsdrURL}/${_id}` : ambsdrURL,
      method: "get",
      body: null,
    }
    const sendAuth = true
    const data = await requestApi(axiosData, sendAuth)
    return data
  } catch (error) {
    return error.response?.data || { status: "error", message: error.message }
  }
}
